/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Sep-22
 *
 **/

import axios from 'axios';
import {errorResponseModel} from "./models";
import * as Storage from './../core/storage.js'

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 50000, //in milliseconds 1000 = 1s
    headers: {
        'Content-Type': 'application/json',
    }
});

const httpClientBase = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 50000, //in milliseconds 1000 = 1s
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin' : '*'

    }
});

const httpClientBackend = axios.create({
    baseURL: process.env.VUE_APP_API_BACKEND_URL,
    timeout: 50000, //in milliseconds 1000 = 1s
    headers: {
        'Content-Type': 'multipart/form-data',
    }
});

const authInterceptor = (config) => {
    let token = Storage.getItem('token')

    if (token == null || token.length < 20 || forceBasicAuth(config.url)){
        config.headers['Authorization'] = 'Basic ' + Buffer.from(`${process.env.VUE_APP_OAUTH20_CLIENT_ID}:${process.env.VUE_APP_OAUTH20_CLIENT_SECRET}`, 'utf8').toString('base64')
    }else {
        config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
}

const forceBasicAuth = (url) => {
    if (url.includes('document_data')) {
        return true
    }

    return false
}

const errorInterceptor = error => {
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging'){
        console.log("error");
        console.log(error);
        console.log(JSON.stringify(error));
    }

    if (error.response.status === 401){
        /*localStorage.removeItem('auth_token')
        localStorage.removeItem('user')
        localStorage.removeItem('authentication')

        //PUSH ALERT MESSAGE "Su cuenta/sessión ha expirado intenta logearse nueva mente"
        if (router.currentRoute.name != 'login'){
            router.push('login')
        }*/
    }

    let errorResponse = errorResponseModel()
    errorResponse.code = error.response.status
    errorResponse.error = error.response.data.error ? error.response.data.error : ''

    if (error.response.data.api_message){
        errorResponse.message = error.response.data.api_message
    }else if (error.response.data.message){
        errorResponse.message = error.response.data.message
    }else {
        errorResponse.message = error.response.data.error_description
    }

    return Promise.reject(errorResponse)
}

const responseInterceptor = response => {
    switch (response.status){
        case 200:
            if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging'){
                console.log(response);
            }

            return response.data
        default:
            if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging'){
                console.log(response);
            }
    }
}

httpClient.interceptors.request.use(authInterceptor)
httpClient.interceptors.response.use(responseInterceptor, errorInterceptor)

httpClientBase.interceptors.request.use(authInterceptor)
httpClientBase.interceptors.response.use(responseInterceptor, errorInterceptor)

httpClientBackend.interceptors.request.use(authInterceptor)
httpClientBackend.interceptors.response.use(responseInterceptor, errorInterceptor)

export {httpClient, httpClientBackend, httpClientBase}
